export default "<nz-progress [nzPercent]=\"time\" nzType=\"circle\"></nz-progress>\r\n"